import React, { Component } from 'react';
import{
    Row,
    Col,
    Input,
    Button,
    Form
} from 'reactstrap';

export class Search extends Component {
  
  render () {
     return (
        <Form className="form"  onSubmit={this.props.handleSearchSubmit}>
            <Row className="d-flex align-items-center no-gutter">
                <Col className="d-flex justify-content-center col-10" style={{padding: "0px", marginLeft: "0px", marginRight: "0px", height: "40px"}}>
                    <Input className="form-control" type="search" name="searchText" style={{width: "100%", height: "100%", padding: "0px", paddingLeft: " ", borderWidth: "medium", borderRadius: "25px", borderTopRightRadius : "0px", borderBottomRightRadius : "0px", borderRight: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}} value={this.props.text} placeholder={this.props.placeholder} onChange={this.props.handleSearchChange}/>
                </Col>
                <Col className="d-flex justify-content-center col-2" style={{padding: "0px", marginLeft: "0px", marginRight: "0px", height: "40px"}}>
                    <Button type="submit" style={{height: "100%", width: "100%", padding: "0px", borderWidth: "medium", borderRadius: "25px",  borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px", borderLeft: "0px", color: "#011e41", borderColor: "#011e41", backgroundColor: "transparent", fontSize: "25px", verticalAlign:"middle", textAlign: "right", fontWeight: "bold", paddingRight: "10px"}}><i className="fa fa-search"></i></Button>                                
                </Col>
            </Row>
        </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Search.js